import React, { useContext } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { Path } from "paths";
import { LocationList, CreateLocation, EditLocation, DeleteLocation } from "modules";
import { useMount } from "hooks";
import { setPageTitle } from "services";
import { VenueContext } from "contexts";
import { isOdooLocationLocked } from "services/venue.service";

const LocationPage = () => {
  const { venue } = useContext(VenueContext);
  // A locked venue creates locations in Odoo, so a typed-in create URL goes back to the list.
  const locationLocked = isOdooLocationLocked(venue);

  useMount(() => {
    setPageTitle("locations");
  });
  return (
    <Switch>
      {locationLocked && <Redirect exact from={Path.LOCATION_CREATE} to={Path.LOCATION} />}
      <Route exact path={Path.LOCATION_CREATE} component={CreateLocation} />
      <Route exact path={Path.LOCATION_DELETE} component={DeleteLocation} />
      <Route exact path={Path.LOCATION_EDIT} component={EditLocation} />
      <Route exact path={Path.LOCATION} component={LocationList} />
    </Switch>
  );
};

export default LocationPage;
